import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FiActivity, FiPlay, FiClock, FiStar } from 'react-icons/fi';
import { Card } from '../common/Card';

export function TodayStats({ markets = [] }) {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('daily');

  const stats = {
    total: markets.length,
    live: markets.filter((m) => m.status === 'live').length,
    upcoming: markets.filter((m) => m.status === 'upcoming').length,
    aiPicks: markets.filter((m) => m.hasAIPick).length,
  };

  const statItems = [
    { icon: FiActivity, label: t('todayStats.total'), value: stats.total, color: 'text-accent' },
    { icon: FiPlay, label: t('todayStats.live'), value: stats.live, color: 'text-positive' },
    { icon: FiClock, label: t('todayStats.upcoming'), value: stats.upcoming, color: 'text-accent-warm' },
    { icon: FiStar, label: t('todayStats.aiPicks'), value: stats.aiPicks, color: 'text-accent-soft' },
  ];



  const leaderboardTabs = [
    { id: 'daily', label: t('leaderboard.daily') },
    { id: 'weekly', label: t('leaderboard.weekly') },
    { id: 'monthly', label: t('leaderboard.monthly') },
    { id: 'total', label: t('leaderboard.total') },
  ];

  return (
    <div className="space-y-4">
      {/* Stats Grid */}
      <div className="glass-card p-4">
        <h3 className="font-bold text-white mb-4 flex items-center gap-2 text-sm">
          <div className="p-1.5 rounded-lg bg-accent/20 text-accent">
            <FiActivity className="w-4 h-4" />
          </div>
          {t('todayStats.title')}
        </h3>
        <div className="grid grid-cols-2 gap-3">
          {statItems.map(({ icon: Icon, label, value, color }) => (
            <div key={label} className="bg-surface/50 border border-white/5 rounded-xl p-3 text-center hover:bg-white/5 transition-colors group">
              <Icon className={`w-5 h-5 mx-auto mb-2 ${color} group-hover:scale-110 transition-transform`} />
              <div className="text-xl font-black text-white mb-0.5 tracking-tight">{value}</div>
              <div className="text-[10px] uppercase tracking-wider text-gray-500 font-bold">{label}</div>
            </div>
          ))}
        </div>
      </div>



    </div>
  );
}
